import React from 'react';

// one data context to rule them all
const DataContext = React.createContext({
    // tags
    tags: [], // TagsService.tags,
    upsertTag: () => {},
    deleteTag: () => {},
    showTag: false,
    updateShowTag: () => {},

    // assets
    assets: {},
    updateAsset: () => {},
    createAsset: () => {},
    showIP: false,
    updateShowIP: () => {},
    deleteAsset: () => {},

    lookups: [],
    filehashLookups: [],

    // mitre
    mitreCategories: () => {},
    mitreCategoriesMap: () => {},
    setAlertMitre: () => {},
    setMtdtMitre: () => {},
    setAlerstMitre: () => {},
    setMtdtsMitre: () => {},
    clearAlertMitre: () => {},
    clearMtdtMitre: () => {},
    clearAlertsMitre: () => {},
    clearMtdtsMitre: () => {},

    // sensors
    sensorNames: {}, // SensorsService.names,

    // alerts
    alertMappings: {},
    setAlertMappings: () => {},

    // metadata
    getMtdtColumnMapping: () => {},
    setMtdtColumnMapping: () => {},

    // system health and notifications
    systemHealth: {},
    setSystemHealth: () => {},

    systemSettings: () => {},
    // set app state
    setSystemSettings: () => {},
    // push update to API
    updateSystemSettings: () => {},

    // probably belongs in some ui state context
    sidenav: {},
    setSidenav: () => {},

    // bt jobs
    backtestingJobsLite: {},
    backtestingJobs: {},
    refreshBacktestingJobs: () => {},
});
DataContext.displayName = 'DataContext';

export {
    DataContext as default,
};
